export default "__VITE_ASSET__BBxWGKnx__"